import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../lib/supabase'

export default function Home() {
  const navigate = useNavigate()
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    checkAuth()
  }, [])

  async function checkAuth() {
    try {
      const { data: { session } } = await supabase.auth.getSession()
      setUser(session?.user || null)
    } catch (error) {
      console.error('Auth check error:', error)
      setUser(null)
    } finally {
      setLoading(false)
    }
  }

  async function handleSignOut() {
    await supabase.auth.signOut()
    setUser(null)
  }

  function handlePrimaryAction() {
    if (user) {
      navigate('/dashboard')
    } else {
      navigate('/signup')
    }
  }

  if (loading) {
    return <div className="loading"><div className="spinner"></div></div>
  }

  return (
    <div style={{ minHeight: '100vh' }}>
      <div className="nav">
        <div className="nav-content">
          <div
            className="nav-title"
            onClick={() => navigate('/')}
            style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '12px' }}
          >
            <span className="typing-animation">&gt; AgencySniper</span>
          </div>
          <div className="nav-actions">
            {user ? (
              <>
                <div style={{ marginRight: '12px', textAlign: 'right' }}>
                  <div style={{ fontSize: '13px', color: '#98FB98', fontWeight: '500', textShadow: '0 0 8px rgba(152, 251, 152, 0.6)' }}>{user.email}</div>
                </div>
                <button onClick={() => navigate('/dashboard')} className="btn" style={{ padding: '10px 20px', fontSize: '14px' }}>
                  Dashboard
                </button>
                <button onClick={handleSignOut} className="btn-secondary" style={{ padding: '10px 20px', fontSize: '14px' }}>
                  Sign Out
                </button>
              </>
            ) : (
              <>
                <button onClick={() => navigate('/login')} className="btn-secondary" style={{ padding: '10px 20px', fontSize: '14px' }}>
                  Sign In
                </button>
                <button onClick={() => navigate('/signup')} className="btn" style={{ padding: '10px 20px', fontSize: '14px' }}>
                  Sign Up
                </button>
              </>
            )}
          </div>
        </div>
      </div>

      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '60px 24px' }}>
        <div style={{ textAlign: 'center', marginBottom: '80px' }}>
          <h1 className="typing-animation" style={{ fontSize: '56px', marginBottom: '16px', fontWeight: '800', fontFamily: 'VT323, monospace', letterSpacing: '3px', display: 'inline-block', marginTop: '32px' }}>
            &gt; AGENCYSNIPER
          </h1>
          <p style={{ fontSize: '28px', color: '#98FB98', lineHeight: '1.4', maxWidth: '700px', margin: '0 auto 24px', textShadow: '0 0 15px rgba(152, 251, 152, 0.7)', fontFamily: 'VT323, monospace', fontWeight: '700', letterSpacing: '2px' }}>
            Laser Targeted Results
          </p>
          <div style={{
            padding: '24px 32px',
            background: 'linear-gradient(135deg, rgba(152, 251, 152, 0.2) 0%, rgba(34, 139, 34, 0.35) 100%)',
            backdropFilter: 'blur(16px)',
            border: '3px solid rgba(152, 251, 152, 0.6)',
            borderRadius: '16px',
            maxWidth: '800px',
            margin: '0 auto 40px',
            boxShadow: '0 8px 20px rgba(34, 139, 34, 0.35), 0 0 40px rgba(152, 251, 152, 0.4), inset 0 2px 0 rgba(152, 251, 152, 0.2)'
          }}>
            <p style={{ fontSize: '17px', color: '#98FB98', lineHeight: '1.9', textShadow: '0 0 12px rgba(152, 251, 152, 0.8)', margin: 0, fontWeight: '500' }}>
              <strong style={{ color: '#98FB98', textShadow: '0 0 15px rgba(152, 251, 152, 1)', fontWeight: '800', letterSpacing: '1px' }}>DISCLAIMER:</strong> AgencySniper is not intended for public use. We employ internal algorithms and API edge functions to reverse engineer critical client information.
            </p>
          </div>
          <button
            className="btn"
            onClick={handlePrimaryAction}
            style={{ padding: '18px 48px', fontSize: '18px', marginRight: '16px' }}
          >
            {user ? 'Access Dashboard →' : 'Request Access →'}
          </button>
          {!user && (
            <button
              className="btn-secondary"
              onClick={() => navigate('/login')}
              style={{ padding: '18px 48px', fontSize: '18px', marginTop: '8px' }}
            >
              Sign In
            </button>
          )}
        </div>

        <div className="card" style={{ marginBottom: '60px' }}>
          <h2 style={{ fontSize: '32px', marginBottom: '32px', color: '#98FB98', fontWeight: '700', textShadow: '0 0 15px rgba(152, 251, 152, 0.7)', textAlign: 'center' }}>
            &gt; System Capabilities
          </h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '32px' }}>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '48px', marginBottom: '16px' }}>📋</div>
              <h3 style={{ fontSize: '20px', marginBottom: '12px', color: '#98FB98', fontWeight: '700', textShadow: '0 0 10px rgba(152, 251, 152, 0.6)' }}>
                Submit Target
              </h3>
              <p style={{ fontSize: '16px', color: 'rgba(152, 251, 152, 0.9)', lineHeight: '1.7', textShadow: '0 0 5px rgba(152, 251, 152, 0.4)' }}>
                Input job posting data from any agency source for analysis
              </p>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '48px', marginBottom: '16px' }}>🎯</div>
              <h3 style={{ fontSize: '20px', marginBottom: '12px', color: '#98FB98', fontWeight: '700', textShadow: '0 0 10px rgba(152, 251, 152, 0.6)' }}>
                Analyze Patterns
              </h3>
              <p style={{ fontSize: '16px', color: 'rgba(152, 251, 152, 0.9)', lineHeight: '1.7', textShadow: '0 0 5px rgba(152, 251, 152, 0.4)' }}>
                Proprietary algorithms identify company signatures and hiring patterns
              </p>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '48px', marginBottom: '16px' }}>✓</div>
              <h3 style={{ fontSize: '20px', marginBottom: '12px', color: '#98FB98', fontWeight: '700', textShadow: '0 0 10px rgba(152, 251, 152, 0.6)' }}>
                Identify Client
              </h3>
              <p style={{ fontSize: '16px', color: 'rgba(152, 251, 152, 0.9)', lineHeight: '1.7', textShadow: '0 0 5px rgba(152, 251, 152, 0.4)' }}>
                Laser targeted results with confidence metrics and verification data
              </p>
            </div>
          </div>
        </div>

        <div className="card" style={{ marginBottom: '60px' }}>
          <h2 style={{ fontSize: '32px', marginBottom: '32px', color: '#98FB98', fontWeight: '700', textShadow: '0 0 15px rgba(152, 251, 152, 0.7)', textAlign: 'center' }}>
            &gt; Core Features
          </h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '24px' }}>
            <div style={{ padding: '24px', background: 'linear-gradient(135deg, rgba(152, 251, 152, 0.08) 0%, rgba(34, 139, 34, 0.2) 100%)', backdropFilter: 'blur(16px)', WebkitBackdropFilter: 'blur(16px)', borderRadius: '16px', border: '2px solid rgba(152, 251, 152, 0.3)', boxShadow: '0 6px 12px rgba(34, 139, 34, 0.15)' }}>
              <h4 style={{ fontSize: '18px', marginBottom: '12px', color: '#98FB98', fontWeight: '700', textShadow: '0 0 10px rgba(152, 251, 152, 0.6)' }}>
                Pattern Recognition
              </h4>
              <p style={{ fontSize: '15px', color: 'rgba(152, 251, 152, 0.9)', lineHeight: '1.7', textShadow: '0 0 5px rgba(152, 251, 152, 0.4)' }}>
                Advanced algorithms identify employer signatures across multiple data points
              </p>
            </div>
            <div style={{ padding: '24px', background: 'linear-gradient(135deg, rgba(152, 251, 152, 0.08) 0%, rgba(34, 139, 34, 0.2) 100%)', backdropFilter: 'blur(16px)', WebkitBackdropFilter: 'blur(16px)', borderRadius: '16px', border: '2px solid rgba(152, 251, 152, 0.3)', boxShadow: '0 6px 12px rgba(34, 139, 34, 0.15)' }}>
              <h4 style={{ fontSize: '18px', marginBottom: '12px', color: '#98FB98', fontWeight: '700', textShadow: '0 0 10px rgba(152, 251, 152, 0.6)' }}>
                Confidence Metrics
              </h4>
              <p style={{ fontSize: '15px', color: 'rgba(152, 251, 152, 0.9)', lineHeight: '1.7', textShadow: '0 0 5px rgba(152, 251, 152, 0.4)' }}>
                Multi-factor confidence scores with detailed breakdown and reasoning
              </p>
            </div>
            <div style={{ padding: '24px', background: 'linear-gradient(135deg, rgba(152, 251, 152, 0.08) 0%, rgba(34, 139, 34, 0.2) 100%)', backdropFilter: 'blur(16px)', WebkitBackdropFilter: 'blur(16px)', borderRadius: '16px', border: '2px solid rgba(152, 251, 152, 0.3)', boxShadow: '0 6px 12px rgba(34, 139, 34, 0.15)' }}>
              <h4 style={{ fontSize: '18px', marginBottom: '12px', color: '#98FB98', fontWeight: '700', textShadow: '0 0 10px rgba(152, 251, 152, 0.6)' }}>
                Verified Sources
              </h4>
              <p style={{ fontSize: '15px', color: 'rgba(152, 251, 152, 0.9)', lineHeight: '1.7', textShadow: '0 0 5px rgba(152, 251, 152, 0.4)' }}>
                All identifications backed by verifiable sources and citations
              </p>
            </div>
            <div style={{ padding: '24px', background: 'linear-gradient(135deg, rgba(152, 251, 152, 0.08) 0%, rgba(34, 139, 34, 0.2) 100%)', backdropFilter: 'blur(16px)', WebkitBackdropFilter: 'blur(16px)', borderRadius: '16px', border: '2px solid rgba(152, 251, 152, 0.3)', boxShadow: '0 6px 12px rgba(34, 139, 34, 0.15)' }}>
              <h4 style={{ fontSize: '18px', marginBottom: '12px', color: '#98FB98', fontWeight: '700', textShadow: '0 0 10px rgba(152, 251, 152, 0.6)' }}>
                Operation History
              </h4>
              <p style={{ fontSize: '15px', color: 'rgba(152, 251, 152, 0.9)', lineHeight: '1.7', textShadow: '0 0 5px rgba(152, 251, 152, 0.4)' }}>
                Complete audit trail of all analyses with searchable archive
              </p>
            </div>
            <div style={{ padding: '24px', background: 'linear-gradient(135deg, rgba(152, 251, 152, 0.08) 0%, rgba(34, 139, 34, 0.2) 100%)', backdropFilter: 'blur(16px)', WebkitBackdropFilter: 'blur(16px)', borderRadius: '16px', border: '2px solid rgba(152, 251, 152, 0.3)', boxShadow: '0 6px 12px rgba(34, 139, 34, 0.15)' }}>
              <h4 style={{ fontSize: '18px', marginBottom: '12px', color: '#98FB98', fontWeight: '700', textShadow: '0 0 10px rgba(152, 251, 152, 0.6)' }}>
                Agency Detection
              </h4>
              <p style={{ fontSize: '15px', color: 'rgba(152, 251, 152, 0.9)', lineHeight: '1.7', textShadow: '0 0 5px rgba(152, 251, 152, 0.4)' }}>
                Automatic identification and filtering of recruiting agencies
              </p>
            </div>
            <div style={{ padding: '24px', background: 'linear-gradient(135deg, rgba(152, 251, 152, 0.08) 0%, rgba(34, 139, 34, 0.2) 100%)', backdropFilter: 'blur(16px)', WebkitBackdropFilter: 'blur(16px)', borderRadius: '16px', border: '2px solid rgba(152, 251, 152, 0.3)', boxShadow: '0 6px 12px rgba(34, 139, 34, 0.15)' }}>
              <h4 style={{ fontSize: '18px', marginBottom: '12px', color: '#98FB98', fontWeight: '700', textShadow: '0 0 10px rgba(152, 251, 152, 0.6)' }}>
                Precision Targeting
              </h4>
              <p style={{ fontSize: '15px', color: 'rgba(152, 251, 152, 0.9)', lineHeight: '1.7', textShadow: '0 0 5px rgba(152, 251, 152, 0.4)' }}>
                Location, tech stack, business fit, and hiring pattern analysis
              </p>
            </div>
          </div>
        </div>

        <div className="card" style={{ textAlign: 'center', marginBottom: '60px', background: 'linear-gradient(135deg, rgba(152, 251, 152, 0.15) 0%, rgba(34, 139, 34, 0.3) 100%)', border: '2px solid rgba(152, 251, 152, 0.5)' }}>
          <h2 style={{ fontSize: '32px', marginBottom: '24px', color: '#98FB98', fontWeight: '700', textShadow: '0 0 15px rgba(152, 251, 152, 0.9)' }}>
            &gt; ACCESS SYSTEM
          </h2>
          <p style={{ fontSize: '18px', color: 'rgba(152, 251, 152, 0.95)', lineHeight: '1.7', maxWidth: '600px', margin: '0 auto 32px', textShadow: '0 0 8px rgba(152, 251, 152, 0.6)' }}>
            Limited access granted. 5 operations per cycle. No authorization required.
          </p>
          <button
            className="btn"
            onClick={handlePrimaryAction}
            style={{ padding: '18px 48px', fontSize: '18px' }}
          >
            {user ? 'Enter System →' : 'Initialize Access →'}
          </button>
        </div>

        <div style={{ textAlign: 'center', padding: '40px 0', borderTop: '1px solid rgba(144, 238, 144, 0.3)' }}>
          <p style={{ fontSize: '14px', color: 'rgba(152, 251, 152, 0.75)', fontWeight: '700', textShadow: '0 0 8px rgba(152, 251, 152, 0.5)', fontFamily: 'VT323, monospace', letterSpacing: '2px' }}>
            &gt; AGENCYSNIPER - LASER TARGETED RESULTS
          </p>
          <p style={{ fontSize: '13px', color: 'rgba(152, 251, 152, 0.65)', marginTop: '8px', textShadow: '0 0 5px rgba(152, 251, 152, 0.4)' }}>
            Internal use only - Proprietary algorithms
          </p>
        </div>
      </div>
    </div>
  )
}
